import { type IFlowAction } from 'widgets/Flow'
import { CallEndsStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions'

export const isHaveParentCallEnds = (
  action: IFlowAction,
  getActionById: (id: string) => IFlowAction | undefined
): boolean => {
  if (action instanceof CallEndsStore) {
    return true
  }
  if (!action.actionStore.parentId) return false
  const parent = getActionById(action.actionStore.parentId)
  if (parent) {
    return isHaveParentCallEnds(parent, getActionById)
  }
  return false
}
